"use strict";

angular.module('app.modals.protocolPicker', [])

    .factory('protocolPickerModal', ['ModalService', function (ModalService) {
        return function () {
            return ModalService.showModal({
                templateUrl: "views/modals/protocolPicker.html",
                controller: 'protocolPickerModalCtrl',
                inputs: {
                    filterObject: undefined
                }
            });
        }
    }])

    .controller("protocolPickerModalCtrl", ['$scope', 'close', 'ENUM',
        function ($scope, close, ENUM) {

            $scope.protocols = angular.copy( ENUM.getProtocols() );

            $scope.toggleProtocol = function (index) {
                var checked = $scope.protocols[index].checked;

                if (checked) {
                    $scope.result = undefined;
                } else {
                    $scope.result = angular.copy($scope.protocols[index]);
                    delete $scope.result['checked'];
                }

                for (var j = 0; j < $scope.protocols.length; ++j) {
                    $scope.protocols[j].checked = false;
                }

                $scope.protocols[index].checked = !checked;
            };

            $scope.save = function () {
                close($scope.result);
            };

            $scope.close = function () {
                close();
            };

        }
    ]);